import { render } from "./ListadoPatrocinador.vue?vue&type=template&id=4b3fd566"
import script from "./ListadoPatrocinador.vue?vue&type=script&lang=js"
export * from "./ListadoPatrocinador.vue?vue&type=script&lang=js"

import "./ListadoPatrocinador.vue?vue&type=style&index=0&id=4b3fd566&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__